let host = window.location.hostname;
let port = 9000;

window.API_SERVER = `http://${host}:${port}`;
window.API_TOKEN =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjoid2Vid2lkZ2V0Iiwib3JpZ2luIjoidW5rbm93biIsImlhdCI6MTQ2NTk5MjQyMX0.nNOCwkVAHSJ9C8MBfpSP9fnxKJlUi8at5Uejj9S_tUE";
window.captchaKey = "6LduJ4EUAAAAACGr80kQJGZRzrRg_q0K4LrQUjsP";

console.log("host:", window.API_SERVER);
